import React from "react";
import {Alert, Col, Row} from "react-bootstrap";
import bluesChasersImg from "../img/bc/unnamed-2.jpg";
import bluesChasersImg2 from "../img/bc/unnamed-7.jpg";

function PFFinaleWithImage({...props}) {
    return (
        <Alert variant="primary">
            <Row className="align-items-center">
                <Col xs={12} lg={4} className="text-center mb-3 mb-lg-0">
                    <img src={bluesChasersImg} alt="The Blues Chasers"
                         style={{width: "100%", maxHeight: "280px", objectFit: "contain"}}/>
                </Col>
                <Col xs={12} lg={4} className="text-center mb-3 mb-lg-0">
                    <div className="fs-5">
                        Finale performance by:
                    </div>
                    <div className="fs-2">
                        <strong>The Blues Chasers</strong>
                    </div>
                    <div className="fs-5">
                        at The Griffin Museum Terrace at 5:30pm.
                    </div>
                </Col>
                <Col xs={12} lg={4} className="text-center">
                    <img src={bluesChasersImg2} alt="The Blues Chasers performing"
                         style={{width: "100%", maxHeight: "280px", objectFit: "contain"}}/>
                </Col>
            </Row>
        </Alert>
    );
}

export default PFFinaleWithImage;
